module.exports = __webpack_public_path__ + "img/img_privacy.fc9715f4.png";